/*
 * File: if-child-exists.ts
 * File Created: 2023-11-27 03:21:15
 * Author: Val Liu <valuis0429@gmail.com>
 *
 * -----
 * Last Modified: 2024-01-31 09:05:46
 * Modified By: Val Liu
 * -----
 */

import { Vue } from "vue-property-decorator";

/// don't use this for now. it only works for the first time.
/// This custom directive provides a declarative way to dynamically insert or remove an element based on its child elements count, enhancing the reactivity and interactivity of Vue applications.
Vue.directive("if-child-exists", {
    bind: (el, binding, vnode) => {
        const commentNode = document.createComment(" ");
        let isElementInDOM = true;

        const lowBound = parseInt(binding.value || 0, 10);

        // Function to count non-comment child nodes
        const countNonCommentChildNodes = (element) => {
            return Array.from(element.childNodes).filter(
                (child: any) => child.nodeType !== Node.COMMENT_NODE,
            ).length;
        };

        // Function to count eligible child nodes (ignoring comments and certain divs)
        const countEligibleChildNodes = (element) => {
            return Array.from(element.childNodes).filter((child: any) => {
                // Ignore comment nodes
                if (child.nodeType === Node.COMMENT_NODE) {
                    return false;
                }

                // Ignore div.vue-portal-target without children
                if (
                    child.nodeType === Node.ELEMENT_NODE &&
                    child.nodeName === "DIV" &&
                    child.classList.contains("vue-portal-target") &&
                    countNonCommentChildNodes(child) === 0
                ) {
                    return false;
                }

                return true;
            }).length;
        };

        const triggerDisplay = () => {
            const parentNode = el.parentNode;

            if (parentNode) {
                const eligibleChildCount = countEligibleChildNodes(el);
                if (eligibleChildCount <= lowBound && isElementInDOM) {
                    parentNode.replaceChild(commentNode, el);
                    isElementInDOM = false;
                } else if (eligibleChildCount > lowBound && !isElementInDOM) {
                    parentNode.replaceChild(el, commentNode);
                    isElementInDOM = true;
                }
            }
        };

        // Attach the observer to the element
        (el as any)._ifChildExistsObserver = new MutationObserver(triggerDisplay);
        (el as any)._ifChildExistsObserver.observe(el, {
            childList: true,
            subtree: true,
        });

        // Delay the initial triggerDisplay until after the DOM has updated
        vnode.context.$nextTick(() => {
            triggerDisplay();
        });
    },
    unbind: (el) => {
        // Access and disconnect the observer
        if ((el as any)._ifChildExistsObserver) {
            (el as any)._ifChildExistsObserver.disconnect();
            delete (el as any)._ifChildExistsObserver;
        }
    },
});
